import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateProductPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.updateProductPerk,
  {
    mutationKey: ['updateProductPerk'],
  },
)
